export enum ApplicabilityStatus {
  Applicable = 'available',
  NotApplicable = 'not_applicable',
  Unavailable = 'no',
}
